import ReactGA from 'react-ga4';
import { Suspense, useEffect, useState } from 'react';

import useUsers from 'src/hooks/useUsers';
import useSettings from 'src/hooks/useSettings';
import Router from 'src/components/Router';
import Loader from 'src/components/Loader';
import { getGoogleAnalyticsMeasurementID } from 'src/config/googleAnalytics';
import { usePendo } from 'src/hooks/usePendo';

const App: React.FC = () => {
  const [isInitialLoadFinished, setIsInitialLoadFinished] = useState<boolean>(false);
  const { loadCurrentUser } = useUsers();
  const { getSettings } = useSettings();
  usePendo();

  useEffect(() => {
    try {
      const googleAnalyticsMeasurementID = getGoogleAnalyticsMeasurementID();
      ReactGA.initialize(googleAnalyticsMeasurementID);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error init Google Analytics', error);
    }
  }, []);

  useEffect(() => {
    const initialLoad = async () => {
      try {
        await loadCurrentUser().unwrap();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Unauthenticated user');
      } finally {
        setIsInitialLoadFinished(true);
      }
      getSettings({ name: 'talent_usage_fee' });
    };

    initialLoad();
  }, []);

  if (!isInitialLoadFinished) return <Loader sx={{ height: '100vh' }} />;

  return (
    <Suspense fallback={<Loader sx={{ height: '100vh' }} />}>
      <Router />
    </Suspense>
  );
};

export default App;
